import { render, staticRenderFns } from "./RecentJobs.vue?vue&type=template&id=06f66f40"
import script from "./RecentJobs.vue?vue&type=script&lang=js"
export * from "./RecentJobs.vue?vue&type=script&lang=js"
import style0 from "./RecentJobs.vue?vue&type=style&index=0&id=06f66f40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports